import React from 'react';
import styled from 'styled-components';
import {motion} from 'framer-motion';

const ShieldContainer = styled(motion.div)`
    width: 200px;
    height: 280px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Shield = styled(motion.div)`
    width: 110px;
    height: 200px;
    position: relative;
    z-index: 2;
    background: linear-gradient(to right, 
        #E8D7C3 0%, 
        #E8D7C3 35%, 
        #2C1810 35%, 
        #2C1810 40%,
        #E8D7C3 40%,
        #E8D7C3 60%,
        #2C1810 60%,
        #2C1810 65%,
        #E8D7C3 65%,
        #E8D7C3 100%
    );
    border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
    border: 2px solid #2C1810;
`;

const CenterStripe = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 18px;
    height: 100%;
    background: #2C1810;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    padding: 20px 0;
`;

const WhiteDiamond = styled.div`
    width: 10px;
    height: 10px;
    background: white;
    transform: rotate(45deg);
`;

const HorizontalBar = styled.div`
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    width: 95%;
    height: 6px;
    background: #2C1810;
    top: ${props => props.top}%;
    
    &::before, &::after {
        content: '';
        position: absolute;
        width: 10px;
        height: 10px;
        background: white;
        border-radius: 50%;
        top: 50%;
        transform: translateY(-50%);
        border: 1px solid #2C1810;
    }
    
    &::before {
        left: -5px;
    }
    
    &::after {
        right: -5px;
    }
`;

const Spear = styled(motion.div)`
    position: absolute;
    width: 6px;
    height: 240px;
    background: linear-gradient(180deg, #8B4513 0%, #654321 100%);
    left: -3px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    border-radius: 3px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);

    /* Spear tip */
    &::before {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 35px solid #C0C0C0;
        top: -32px;
        left: 50%;
        transform: translateX(-50%);
        filter: drop-shadow(0 3px 3px rgba(0,0,0,0.4));
    }

    /* Spear tip detail */
    &::after {
        content: '';
        position: absolute;
        width: 2px;
        height: 25px;
        background: linear-gradient(180deg, #E8E8E8 0%, #C0C0C0 100%);
        top: -28px;
        left: 50%;
        transform: translateX(-50%);
    }
`;

const SpearGrip = styled.div`
    position: absolute;
    width: 14px;
    height: 40px;
    background: #654321;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 7px;

    &::before, &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 3px;
        background: #8B4513;
        left: 0;
    }

    &::before {
        top: 10px;
    }

    &::after {
        bottom: 10px;
    }
`;

const SpearEnd = styled.div`
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 16px;
    height: 16px;
    background: #8B4513;
    border-radius: 50%;
    border: 2px solid #654321;
`;

const Axe = styled(motion.div)`
    position: absolute;
    width: 6px;
    height: 240px;
    background: linear-gradient(180deg, #8B4513 0%, #654321 100%);
    right: -3px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 1;
    border-radius: 3px;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
`;

const AxeHead = styled.div`
    position: absolute;
    top: -10px;
    right: -5px;
    width: 60px;
    height: 50px;

    /* Main blade */
    &::before {
        content: '';
        position: absolute;
        width: 55px;
        height: 45px;
        background: linear-gradient(135deg, #E8E8E8 0%, #C0C0C0 50%, #A9A9A9 100%);
        clip-path: polygon(80% 0%, 100% 20%, 100% 80%, 80% 100%, 0% 50%);
        right: 0;
        top: 0;
        filter: drop-shadow(2px 2px 3px rgba(0,0,0,0.4));
    }

    /* Blade edge highlight */
    &::after {
        content: '';
        position: absolute;
        width: 50px;
        height: 3px;
        background: linear-gradient(90deg, transparent 0%, #FFFFFF 50%, transparent 100%);
        top: 50%;
        right: 5px;
        transform: translateY(-50%);
    }
`;

const AxeBinding = styled.div`
    position: absolute;
    width: 18px;
    height: 25px;
    background: #654321;
    top: 15px;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 3px;

    &::before {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        background: #8B4513;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
    }
`;

const AxeGrip = styled.div`
    position: absolute;
    width: 14px;
    height: 50px;
    background: #654321;
    bottom: 30%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 7px;

    &::before, &::after {
        content: '';
        position: absolute;
        width: 100%;
        height: 3px;
        background: #8B4513;
        left: 0;
    }

    &::before {
        top: 12px;
    }

    &::after {
        bottom: 12px;
    }
`;

const AxeEnd = styled.div`
    position: absolute;
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
    width: 16px;
    height: 16px;
    background: #8B4513;
    border-radius: 50%;
    border: 2px solid #654321;
`;

const DancingShield = () => {
    // Animation variants
    const containerVariants = {
        dance: {
            y: [0, -15, 0],
            transition: {
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    };

    const shieldVariants = {
        dance: {
            rotate: [-3, 3, -3],
            scale: [1, 1.02, 1],
            transition: {
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    };

    const spearVariants = {
        dance: {
            rotate: [-15, 15, -15],
            y: [-10, 10, -10],
            transition: {
                duration: 2.5,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    };

    const axeVariants = {
        dance: {
            rotate: [15, -15, 15],
            y: [10, -10, 10],
            transition: {
                duration: 2.5,
                repeat: Infinity,
                ease: "easeInOut"
            }
        }
    };

    return (
        <ShieldContainer variants={containerVariants} animate="dance">
            {/* Spear on the left */}
            <Spear variants={spearVariants} animate="dance">
                <SpearGrip />
                <SpearEnd />
            </Spear>

            {/* Central Traditional Zulu Shield */}
            <Shield variants={shieldVariants} animate="dance">
                <CenterStripe>
                    <WhiteDiamond />
                    <WhiteDiamond />
                    <WhiteDiamond />
                    <WhiteDiamond />
                    <WhiteDiamond />
                    <WhiteDiamond />
                    <WhiteDiamond />
                    <WhiteDiamond />
                </CenterStripe>
                <HorizontalBar top="20" />
                <HorizontalBar top="35" />
                <HorizontalBar top="50" />
                <HorizontalBar top="65" />
                <HorizontalBar top="80" />
            </Shield>

            {/* Axe on the right */}
            <Axe variants={axeVariants} animate="dance">
                <AxeHead />
                <AxeBinding />
                <AxeGrip />
                <AxeEnd />
            </Axe>
        </ShieldContainer>
    );
};

export default DancingShield;